import { Root } from '@radix-ui/react-dropdown-menu';
import { ComponentPropsWithoutRef } from 'react';
import { DropdownContent } from './dropdown-content';
import { DropdownGroup } from './dropdown-group';
import { DropdownItem } from './dropdown-item';
import { DropdownLabel } from './dropdown-label';
import { DropdownPortal } from './dropdown-portal';
import { DropdownSeparator } from './dropdown-separator';
import { DropdownTrigger } from './dropdown-trigger';

type Props = ComponentPropsWithoutRef<typeof Root>;
const DropdownRoot = (props: Props) => {
    return <Root data-testid="dropdown" {...props} />;
};

export const Dropdown = Object.assign(DropdownRoot, {
    Portal: DropdownPortal,
    Trigger: DropdownTrigger,
    Content: DropdownContent,
    Group: DropdownGroup,
    Label: DropdownLabel,
    Item: DropdownItem,
    Separator: DropdownSeparator,
});

export { DropdownRoot as Root };
export { DropdownContent as Content } from './dropdown-content';
export { DropdownGroup as Group } from './dropdown-group';
export { DropdownItem as Item } from './dropdown-item';
export { DropdownLabel as Label } from './dropdown-label';
export { DropdownSeparator as Separator } from './dropdown-separator';
export { DropdownTrigger as Trigger } from './dropdown-trigger';
